import { ShieldWarning, ArrowClockwise } from "@phosphor-icons/react";

const VideoBlockedBox = ({ reset }: { reset: () => void }) => (
  <div className="flex flex-col items-center justify-center h-full p-4">
    <div className="bg-surface-1 border border-white/[0.08] max-w-sm px-8 pt-8 pb-6 rounded-2xl">
      <div className="w-14 h-14 rounded-full bg-myAmber/10 flex items-center justify-center mx-auto mb-4">
        <ShieldWarning size={28} className="text-myAmber" weight="duotone" />
      </div>
      <p className="text-base text-white font-semibold mb-2 text-center">
        Video yüklenemedi
      </p>
      <p className="text-sm text-white/50 leading-relaxed mb-5">
        Tarayıcın video servisine bağlanamadı. Genellikle şu sebeplerden biridir:
      </p>
      <ul className="text-sm text-white/60 leading-relaxed mb-6 space-y-2 list-disc pl-5">
        <li>
          <span className="text-white/80">Reklam engelleyici uzantı</span>{" "}
          (uBlock, AdBlock, AdGuard). Siteyi izinli listene ekleyip sayfayı yenile.
        </li>
        <li>
          <span className="text-white/80">Gizlilik uzantısı</span>{" "}
          (Privacy Badger, Ghostery, Brave Shields). Aynı şekilde bu site için izin ver.
        </li>
        <li>
          <span className="text-white/80">Farklı bir tarayıcı dene</span> —{" "}
          Microsoft Edge veya Firefox ile aç.
        </li>
      </ul>
      <button
        onClick={reset}
        className="w-full inline-flex items-center justify-center gap-2 px-4 py-2 bg-white/5 hover:bg-white/10 border border-white/[0.08] text-white text-sm font-medium rounded-xl transition-colors cursor-pointer"
      >
        <ArrowClockwise size={16} weight="bold" />
        Yeniden Dene
      </button>
    </div>
  </div>
);

export default VideoBlockedBox;
